(function () {
  'use strict';

  window.addEventListener('hashchange', onHashchange);

  var isIE = /MSIE (\d+\.\d+);/.test(navigator.userAgent) || /Windows Phone/i.test(navigator.userAgent) || /Trident.*rv:11\./.test(navigator.userAgent);

  function onHashchange() {
    if (location.hash.length > 1 && location.hash.substr(0, 7) !== '#state-') {
      return;
    }

    // If IE, force redraw.
    if (isIE) {
      document.body.className += '';
    }
  }
})();
